import AssistantAPISources from './api-sources';
import AssistantIntegrations from './integrations';
import AssistantKnowledge from './knowledge';
import AssistantSkills from './skills';
import AssistantFeedbacks from './feedbacks';
import AssistantMemories from './memories';

class Assistants {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/assistants`;
    this.apiSources = new AssistantAPISources(basePath, apiClient);
    this.integrations = new AssistantIntegrations(basePath, apiClient);
    this.knowledge = new AssistantKnowledge(basePath, apiClient);
    this.skills = new AssistantSkills(basePath, apiClient);
    this.feedbacks = new AssistantFeedbacks(basePath, apiClient);
    this.memories = new AssistantMemories(basePath, apiClient);

  }

  getAssistantByStartupId() {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, {}, {});

  }

  getConversationDetail() {

    const path = `${this.basePath}/conversation-details`;

    return this.apiClient.get(path, {}, {});

  }

  updateConversationDetail(data) {

    const path = `${this.basePath}/conversation-details`;

    return this.apiClient.put(path, {}, {}, data);

  }

  updateAssistantAndHumanFriendlyId(assistantId, assistant) {

    const path = `${this.basePath}/:assistantId`;

    return this.apiClient.put(path, { assistantId }, {}, assistant);

  }

  getSkillsByAssistantId(assistantId) {

    const path = `${this.basePath}/:assistantId/bots`;

    return this.apiClient.get(path, {
      assistantId
    });

  }

  updateSkill(assistantId, skillId, skill) {

    const path = `${this.basePath}/:assistantId/bots/:skillId`;

    return this.apiClient.put(path, { assistantId, skillId }, {}, skill);

  }

  getSkillById(assistantId, skillId) {

    const path = `${this.basePath}/:assistantId/bots/:skillId`;

    return this.apiClient.get(path, {
      assistantId,
      skillId
    });

  }

  getResourcesBySkillId(assistantId, skillId, queryOptions) {

    const path = `${this.basePath}/:assistantId/bots/:skillId/resources`;

    return this.apiClient.get(path, { assistantId, skillId }, queryOptions);

  }

  resyncResource(assistantId, skillId, resourceId) {

    const path = `${this.basePath}/:assistantId/bots/:skillId/resources/:resourceId/resync`;

    return this.apiClient.post(path, { assistantId, skillId, resourceId }, {}, {});

  }

  deleteResource(assistantId, skillId, resourceId) {

    const path = `${this.basePath}/:assistantId/bots/:skillId/resources/:resourceId`;

    return this.apiClient.delete(path, { assistantId, skillId, resourceId });

  }

  createSkill(assistantId, skill) {

    const path = `${this.basePath}/:assistantId/bots`;

    return this.apiClient.post(path, { assistantId }, {}, skill);

  }

  uploadSkillFile(assistantId, file) {

    const path = `${this.basePath}/:assistantId/files`;

    return this.apiClient.upload(path, { assistantId }, {}, file);

  }

  enableSkill(assistantId, skillId) {

    return this.apiClient.post(`${this.basePath}/:assistantId/bots/:skillId/enable`, {
      assistantId,
      skillId
    }, {}, {});

  }

  disableSkill(assistantId, skillId) {

    return this.apiClient.post(`${this.basePath}/:assistantId/bots/:skillId/disable`, {
      assistantId,
      skillId
    }, {}, {});

  }

  getAssistantVersions(assistantId) {

    return this.apiClient.get(`${this.basePath}/:assistantId/versions`, {
      assistantId
    });

  }

  getSkillVersions(assistantId, skillId) {

    return this.apiClient.get(`${this.basePath}/assistantId/skills/:skillId/versions`, {
      assistantId,
      skillId
    });

  }

}

export default Assistants;